import React from "react";
import { Col, Row } from "react-bootstrap";
import { isRgbColorEnabled, getScaleColors } from "../../../../../../Helpers/RgbColorHelper";

export default function Summary_L_Bar_Thin({ item, isSub }) {
  let elementScore = item.normScore ? Math.round(Number(item.normScore)) : Math.round(item.score);

  // Check if RGB color is enabled using helper
  const rgbEnabled = isRgbColorEnabled(item.scale);

  // Get color variations using helper only if RGB is enabled
  const colors = rgbEnabled ? getScaleColors(item.scale) : null;

  // Default colors
  const progressColor = rgbEnabled ? colors.primary : "#4a90e2";
  const backgroundColor = rgbEnabled ? colors.light : "#e0e0e0";

  return (
    <Row className={"mb-1 mx-0"}>
      <Col xs="3" className="d-flex align-items-center justify-content-center">
        <div
          style={{
            fontSize: isSub ? "14px" : "18px",
            fontWeight: "600",
            color: rgbEnabled ? (!isSub ? colors.dark : colors.primary) : "#333",
          }}
        >
          {item.name}
        </div>
      </Col>
      <Col xs="9">
        <div style={{ display: "flex", alignItems: "center", gap: "10px", float: "right", width: "100%" }}>
          {/* Percentage text */}
          <div
            style={{
              fontSize: "18px",
              fontWeight: "600",
              color: rgbEnabled ? colors.dark : "#333",
              minWidth: "50px",
              flexShrink: 0,
            }}
          >
            {elementScore}%
          </div>

          {/* Loading bar - Thinner version */}
          <div
            style={{
              flex: 1,
              height: "10px",
              backgroundColor: backgroundColor,
              borderRadius: "5px",
              overflow: "hidden",
              position: "relative",
            }}
          >
            <div
              style={{
                height: "100%",
                width: `${elementScore}%`,
                backgroundColor: progressColor,
                borderRadius: "5px",
                transition: "width 0.3s ease",
              }}
            />
          </div>
        </div>
      </Col>
    </Row>
  );
}
